export function removeDomain(url: string) {
	return url.replace(
		/^[a-z]{4,5}\:\/{2}[a-z0-9\.]{1,}[\:]{0,1}[0-9]{0,4}(.*)/,
		'$1'
	);
}
